import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="M40.24 58 43 59.44a20.35 20.35 0 0 1-40-5.32V38.84l3 1.55 16.4 8.45.56.28ZM26.92 47.28l14 7.2L43.84 56a14.48 14.48 0 0 0 .16-2.28V38.48L41 40ZM44 22v13.28l-3 1.56-17.5 8.92L6 36.84l-3-1.56V22.46a20.74 20.74 0 0 1 6.13-15 20.61 20.61 0 0 1 24.62-3.1A20.32 20.32 0 0 1 44 22ZM25.55 10.76l-2.16 3.52a.74.74 0 0 0-.12.56.73.73 0 0 0 .32.48.88.88 0 0 0 1.16-.2 1.45 1.45 0 0 1 1-.61 1.42 1.42 0 0 1 1.11.29 1.47 1.47 0 0 1 .32 2.08 3.69 3.69 0 0 1-3.08 1.56 3.77 3.77 0 0 1-2.2-.68 3.81 3.81 0 0 1-1-5.08L22 10.8A11.64 11.64 0 0 0 12.27 22a11.56 11.56 0 0 0 23.12 0 11.64 11.64 0 0 0-9.84-11.2Z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
